module.exports = __webpack_public_path__ + "media/14.7be33c12.mp4";